import { DRIZZLE_KIT_POSTGRES_DRIVER_DEP } from '@cli-constants/deps.js'
import { hasProjectDependency } from './has-project-dependency.js'

export function hasDrizzleKitPostgresDriverDependency(cwd: string): boolean {
  return hasProjectDependency(cwd, DRIZZLE_KIT_POSTGRES_DRIVER_DEP)
}
